import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getPortfolioUserByStore, getPortfolioUserByStoreFilter } from "./Services";



export const useGetPortfolioUserByStoreFilter = (filter:any) => {
  return useQuery(
    [endpoints.getPortfolioUserByStoreFilter,filter],
    () => getPortfolioUserByStoreFilter(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetPortfolioUserByStore = (storeId:string) => {
  return useQuery(
    [endpoints.getPortfolioUserByStoreFilter,storeId],
    () => getPortfolioUserByStore(storeId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
